<template>
  <div>
    <div class="outside-border">
      <div class="silencer"></div>
      <div class="volume-up"></div>
      <div class="volume-down"></div>
      <div class="button-on"></div>
      <div class="inside-border">
        <!-- Camera -->
        <div class="camera">
          <div class="camera-dot">
            <div class="camera-dot-2"></div>
            <div class="camera-dot-3"></div>
          </div>
          <div class="camera-speaker">
          </div>
        </div>
        <!-- CONTENT START -->
        <slot></slot>
        <!-- CONTENT END -->

        <!-- Battery and Signal -->

        <div class="t-r-info">
          <div class="dots">
            ...
          </div>
          <div class="battery">
            <div class="bar"></div>
            <div class="dot"></div>
          </div>
        </div>

        <!-- Bottom Line -->

        <div class="bottom-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IPhoneSkeleton',
}
</script>
<style lang="scss" scoped>
$box_shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12);

.outside-border {
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  width: 212px;
  height: 438px;
  border: 0.6px solid black;
  margin-left: -9px;
  border-radius: 35px;
}

.silencer {
  position: absolute;
  background-color: black;
  border-radius: 5px;
  width: 2px;
  height: 13px;
  left: -2px;
  top: 81.5px;
  opacity: 0.8;
}

.volume- {
  &up,
  &down {
    position: absolute;
    background-color: black;
    border-radius: 5px;
    height: 28px;
    width: 1px;
    left: -1.5px;
    opacity: 0.8;
  }
  &up {
    top: 110px;
  }
  &down {
    top: 148px;
  }
}

.button-on {
  position: absolute;
  background-color: black;
  border-radius: 5px;
  height: 45px;
  width: 2px;
  right: -2px;
  opacity: 0.8;
  top: 121px;
}

.inside-border {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 6px solid black;
  border-radius: 35px;
  background: #f6f6f6;
  overflow: hidden;
}

.camera {
  display: flex;
  justify-content: center;
  position: relative;
  width: 76px;
  height: 20px;
  background-color: black;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  top: 0;
}

.camera-dot {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  width: 5px;
  height: 5px;
  left: 12px;
  top: 5px;
}

.camera-dot-2 {
  position: absolute;
  background-color: #000000;
  border-radius: 50%;
  width: 4px;
  height: 4px;
  opacity: 0.3;
  box-shadow: $box_shadow;
  filter: blur(1px);
}

.camera-dot-3 {
  position: absolute;
  background-color: #000;
  border-radius: 50%;
  width: 1px;
  height: 1px;
  opacity: 0.7;
}

.camera-speaker {
  position: absolute;
  background-color: #000000;
  width: 28px;
  height: 1px;
  border-radius: 20px;
  top: -3px;
  opacity: 0.2;
}

.t-r-info {
  display: flex;
  gap: 5px;
  position: absolute;
  right: 17px;
  top: 8px;
  font-size: 10px;
}

.battery {
  position: relative;
  margin-top: 4px;
  height: 7px;
  width: 14px;
  border: 0.7px solid rgba(0, 0, 0, 0.709);
  border-radius: 2px;
  .bar {
    width: calc(80% - 2px);
    height: calc(100% - 2px);
    background-color: #000000;
    margin: 1px;
    border-radius: 1px;
  }
  .dot {
    position: absolute;
    right: -2px;
    top: 1.5px;
    width: 1px;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.709);
    border-radius: 2px;
  }
}

.bottom-line {
  position: absolute;
  height: 2px;
  width: 80px;
  background-color: #000000;
  bottom: 6px;
  border-radius: 2px;
  opacity: 0.8;
}
</style>
